import IMAGES from '../public/assets/img/index';

export const BANNERPAGE = {

  // banner section

  domestic: {
    name: "Credlix for all your Invoices",
    id: 0,
    banner: [
      {
        title: "Credlix for SMES: Invoice Discounting for Small Scale Industries & Businesses",
        subtitle: "Get immediate working capital on up to 90% of your invoice value",
        paratitle: "With our invoice discounting solutions, you can now secure faster funding for all your invoices using minimal documentation and no collateral.",
        bannerimg: IMAGES.DOMESTIC.banner,
        url:'/invoice-discounting-for-smes',
        cta:'Get Financed'
      },
    ],
  },

  invoicediscounting: {
    name: "Credlix for Enterprises: Invoice Discounting",
    id: 0,
    banner: [
      {
        title: "Credlix for Exporters: Best Invoice Discounting Platform in India",
        subtitle: " Get immediate working capital on up to 90% of your invoice value",
        paratitle: "With our export financing solutions, you can now secure faster funding for your export invoices using minimal documentation and zero hard collateral.",
        bannerimg: IMAGES.INVOICEDISCOUNTING.banner,
        url:'/export-factoring/invoice-discounting-platform',
       
      },
    ],
  },




  // Explore Credlix Solutions For Your Enterprise right image

  domestic1: {
    name: "Purchase Order Finance",
    id: 0,
    data: [
      {
        heading:"Explore Credlix Solutions",
        title: "Purchase Order Finance",
        subtitle: "Get cash flow based lending based on purchase orders",
        learncta: "Learn More",
        url:'/export-factoring/purchase-order-financing',
        exploreimg: IMAGES.EXPLOREIMG.domesticimg,
       
      },
    ],
  },

  purorder: {
    name: "Invoice Discounting",
    id: 0,
    data: [
      {
        heading:"Explore Credlix Solutions",
        title: "Invoice Discounting",
        subtitle: "Get your invoices discounted and access outstanding payments faster",
        learncta: "Learn More",
        url:"/export-factoring/invoice-discounting-platform",
        exploreimg: IMAGES.EXPLOREIMG.purchorder,
       
      },
    ],
  },

  earlycard: {
    name: "Vendor Finance",
    id: 0,
    data: [
      {
        heading:"Explore Credlix Solutions For Your Enterprise",
        title: "Vendor Finance",
        subtitle: "Offer cash-flow lending to suppliers based on our digital authentication of their credit profiles. ",
        learncta: "Learn More",
        url:"/enterprise/vendor-financing-india",
        exploreimg: IMAGES.EARLYPAYMENTIMG.cardimg,
       
      },
    ],
  },

  vendorcard: {
    name: "Early Payments",
    id: 0,
    data: [
      {
        heading:"Explore Credlix Solutions For Your Enterprise",
        title: "Early Payments",
        subtitle: "Unfold our early payment program to generate desirable returns on cash and support your supplier partners.",
        learncta: "Learn More",
        url:"/enterprise/early-payment-discount",
        exploreimg: IMAGES.VENDORPAYMENTIMG.cardimg,
       
      },
    ],
  },

  channelcard: {
    name: "Early Payments",
    id: 0,
    data: [
      {
        heading:"Explore Credlix Solutions For Your Enterprise",
        title: "Early Payments",
        subtitle: "Unfold our early payment program to generate desirable returns on cash and support your supplier partners.",
        learncta: "Learn More",
        url:"/enterprise/early-payment-discount",
        exploreimg: IMAGES.VENDORPAYMENTIMG.cardimg,
       
      },
    ],
  },

  // Explore Credlix Solutions For Your Enterprise right image

  earlycardright: {
    name: "Channel Finance",
    id: 0,
    data: [
      {
        title: "Channel Finance",
        subtitle: "Power your distribution network with frictionless financing to grow your company’s sales throughput ",
        learncta: "Learn More",
        url:"/enterprise/channel-financing-india",
        exploreimg: IMAGES.EARLYPAYMENTIMG.cardimgright,
       
      },
    ],
  },

  vendorcardright: {
    name: "Vendor Finance",
    id: 0,
    data: [
      {
        title: "Vendor Finance",
        subtitle: "Offer cash-flow lending to suppliers based on our digital authentication of their credit profiles.",
        learncta: "Learn More",
        url:"/enterprise/vendor-financing-india",
        exploreimg: IMAGES.EARLYPAYMENTIMG.cardimg,
       
      },
    ],
  },

  purcardright: {
    name: "Purchase Order Finance",
    id: 0,
    data: [
      {
        title: "Purchase Order Finance",
        subtitle: "Get up to 40% of purchase order value financed. We fund against your confirmed purchase orders from your overseas buyers.",
        learncta: "Learn More",
        url:"/export-factoring/purchase-order-financing",
        exploreimg: IMAGES.EXPLOREIMG.domesticimg,
       
      },
    ],
  },

  // Carefully Crafted To Manage Your Finances

  craftedcommon:{
    name:"Carefully Crafted To Manage Your Finances",
    id:0,
    datacrafted: [
      {
        iconimg: IMAGES.DOMESTIC.clock,
        iconimg1: IMAGES.DOMESTIC.finance,
        iconimg3: IMAGES.DOMESTIC.crediline,
        iconimg2: IMAGES.DOMESTIC.digitalprocess,
        iconheading: "Short term relief for suppliers",
        iconsubheading: "Discount invoices to improve cash flow and help fund future material movement",
        iconheading1: "Up to 90% of invoices financed",
        iconsubheading1: "Bolster your working capital and receive funds without waiting for buyers to pay",
        iconheading2: "Completely digital process",
        iconsubheading2: "No lengthy paperwork, faster fulfilment, and a completely transparent process",
        iconheading3: "Multiple Credit lines",
        iconsubheading3: "Leverage a digitized workflow and create more visibility for easy credit access with multiple lenders",
        cta:"Request Demo"
      }
    ]
  },

  craftedcommon2:{
    name:"Carefully Crafted To Manage Your Finances",
    id:1,
    datacrafted1: [
      {
        iconimg: IMAGES.INVOICEDISCOUNTING.clockimg,
        iconimg1: IMAGES.INVOICEDISCOUNTING.invoicefina,
        iconimg3: IMAGES.INVOICEDISCOUNTING.digipro,
        iconimg2: IMAGES.INVOICEDISCOUNTING.credline,
        iconheading: "Short term relief for suppliers",
        iconsubheading: "Discount invoices to improve cash flow and help fund future material movement ",
        iconheading1: "Up to 90% of invoices financed",
        iconsubheading1: "Bolster your working capital and receive funds without waiting for buyers to pay ",
        iconheading2: "Completely digital process",
        iconsubheading2: "No lengthy paperwork, faster fulfillment, and a completely transparent process ",
        iconheading3: "Multiple Credit lines",
        iconsubheading3: "Leverage a digitized workflow and create more visibility for easy credit access with multiple lenders",
        cta:"Apply Instant Loan"
      }
    ]
  },



  craftedcommon1:{
    name:"Carefully Crafted To Manage Your Finances",
    id:0,
    datacrafted1: [
      {
        breakimg:IMAGES.EARLYPAYMENTIMG.break,
        workflowimg:IMAGES.EARLYPAYMENTIMG.workflow,
        easyonimg:IMAGES.EARLYPAYMENTIMG.easyon,
        longtailimg:IMAGES.EARLYPAYMENTIMG.longtail,
        heading:"Break the credit cycle and boost returns",
        subheading:"Streamline cash flow and generate higher returns on your funds. Use your corporate treasury to create a cash-flow funnel for your chosen suppliers and improve your returns.",
        heading1:"End to end customized and automated workflows",
        subheading1:"With the help of a digitized workflow, you get access to working capital in two clicks with visibility into every transaction in your supply chain on the Credlix platform.",
        heading2:"Easy onboarding, communication, and reconciliation",
        subheading2:"Traditional financing can bury you and your suppliers in paperwork. Credlix simplifies enrollment and discounting to a few clicks with minimal documentation",
        heading3:"Improve long tail participation, inclusivity and better returns",
        subheading3:"Enable wholesale enrolment of your supplier base into the digital supply chain financing ecosystem to drive holistic adoption across the board and optimize your returns.",
        cta:"Apply Instant Loan"
      }
    ]
  },

  craftedcommon3:{
    name:"Carefully Crafted To Manage Your Finances",
    id:0,
    datacrafted1: [
      {
        iconimg:IMAGES.VENDORPAYMENTIMG.easyvendorimg,
        iconimg1:IMAGES.VENDORPAYMENTIMG.multivendorimg,
        iconimg2:IMAGES.VENDORPAYMENTIMG.crediline,
        iconimg3:IMAGES.VENDORPAYMENTIMG.workflowsimg,
        iconheading:"Easy Vendor Onboarding",
        iconsubheading:"Empower your suppliers with discounted accounts receivable in just two clicks ",
        iconheading1:"Multiple Lender Options",
        iconsubheading1:"Enable integration with your systems and link multiple banks and NBFCS to cover suppliers of all sizes",
        iconheading2:"Extended Credit Lines",
        iconsubheading2:"Traditional financing can bury you and your suppliers in paperwork. Credlix simplifies enrollment and discounting to a few clicks with minimal documentation",
        iconheading3:"Digital Workflows",
        iconsubheading3:"Manage credit requests and reconciliations directly with lenders on the Credlix platform",
        cta:"Apply Instant Loan"
      }
    ]
  },

  craftedcommon4:{
    name:"Carefully Crafted To Manage Your Finances",
    id:0,
    datacrafted1: [
      {
        iconimg:IMAGES.EXPLOREIMG.upfina,
        iconimg1:IMAGES.EXPLOREIMG.intsolu,
        iconimg2:IMAGES.EXPLOREIMG.wallet,
        iconimg3:IMAGES.EXPLOREIMG.handblue,
        iconheading:"Upfront finance",
        iconsubheading:"Get up to 90% of the invoice value upon shipment. No more waiting 30-120 days for your export receivables",
        iconheading1:"An integrated solution",
        iconsubheading1:"Sort your entire working capital journey. Leverage Credlix’s post shipment and purchase order financing benefits on one single platform. ",
        iconheading2:"Cover your Buyer’s credit risk",
        iconsubheading2:"We are more than just credit insurance cover that you take. Say goodbye to a longer waiting period, lengthy claim filing paperwork, and complex approval process. ",
        iconheading3:"Access higher credit limit",
        iconsubheading3:"Access credit up to USD 3 million and use your working capital to grow your business exponentially",
        cta:"Request Demo"
      }
    ]
  },

  craftedcommon5:{
    name:"Carefully Crafted To Manage Your Finances",
    id:0,
    datacrafted1: [
      {
        iconimg:IMAGES.PURCHASEORDERFINANCE.financeimg,
        iconimg1:IMAGES.PURCHASEORDERFINANCE.customimg,
        iconimg2:IMAGES.PURCHASEORDERFINANCE.crediline,
        iconimg3:IMAGES.PURCHASEORDERFINANCE.tech,
        iconheading:"Get up to 40% of purchase order value financed",
        iconsubheading:"Unlock access to funding before your shipment ",
        iconheading1:"Customize your disbursal tenure and amount",
        iconsubheading1:"Supply Chain financing tailor-made for your business and industry requirements ",
        iconheading2:"Competitive credit costs",
        iconsubheading2:"Financing available at affordable rates for Exporters",
        iconheading3:"Tech-enabled finance",
        iconsubheading3:"With the help of a fully digitized solution, get access to working capital anytime. ",
        cta:"Apply Instant Loan"
      }
    ]
  },

 
};